<template>
    <div class="support-login">
        <form class="ct-register-form ct-card form-horizontal" v-on:keyup.enter="login()">
            <section>
                <h3>{{ $t('label.login') }}</h3>
                <div class="ct-input-element">
                    <div class="ct-title ct-v-align">
                        <label for="username">{{ $t('label.username') }}*</label>
                    </div>
                    <div class="ct-content">
                        <input id="username" v-model="username" class="form-control" type="text" />
                    </div>
                </div>
                <div class="ct-input-element">
                    <div class="ct-title ct-v-align">
                        <label for="password">{{ $t('label.password') }}*</label>
                    </div>
                    <div class="ct-content">
                        <input id="password" v-model="password" class="form-control" type="password" />
                    </div>
                </div>
            </section>
            <section class="notice-area">
                <div v-if="showMessage">
                    <div class="alert alert-danger" role="alert">{{ $t('support.login.error') }}</div>
                </div>
                <div v-if="showSpinner">
                    <spinner></spinner>
                </div>
            </section>
            <section class="ct-action">
                <div class="ct-input-element">
                    <button class="btn btn-primary btn-lg btn-block" type="button" v-on:click="login()">
                        {{ $t('button.login') }}
                    </button>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
import auth from '../services/auth.js';
import TextInput from '../../components/inputs/TextInput.vue';
import Spinner from '../../components/Spinner.vue';

export default {
    data: function() {
        return {
            username: '',
            password: '',
            showSpinner: false,
            showMessage: false
        };
    },
    components: {
        TextInput,
        Spinner
    },
    computed: {
        loginFailed() {
            return this.$store.getters['authentication/loginFailed'];
        },
        tokenExpired() {
            return this.$store.getters['authentication/tokenExpired'];
        },
        showValidationsErrors: function() {
            return this.$store.getters['registrations/showValidationErrors'];
        }
    },
    methods: {
        login: function() {
            this.showSpinner = true;
            this.showMessage = false;
            auth.login(this, this.username, this.password)
                .then(() => {
                    this.$store.dispatch('authentication/resetLoginMessages');
                    this.showSpinner = false;
                    this.$store.dispatch('users/loginUser');
                    this.$router.push({
                        name: 'RegistrationDuplicates'
                    });
                })
                .catch(context => {
                    this.showMessage = true;
                    this.showSpinner = false;
                });
        }
    }
};
</script>
<style>
.support-login .lds-css {
    height: 0;
}

.notice-area {
    position: relative;
}

.notice-area > div {
    position: absolute;
    left: 15%;
    right: 15%;
}
</style>
